import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Venue } from 'src/common/common.interface'

export interface VenueState {
  venues?: Venue[]
  countVenue: number
  isLoadingGetVenues: boolean
}

const initialState: VenueState = {
  venues: undefined,
  countVenue: 0,
  isLoadingGetVenues: false
}

const venueSlice = createSlice({
  name: 'venue',
  initialState,
  reducers: {
    setVenuesData(state, action: PayloadAction<Venue[]>) {
      state.venues = action.payload
    },
    setCountVenues(state, action: PayloadAction<number>) {
      state.countVenue = action.payload
    },
    setIsLoadingGetVenues(state, action: PayloadAction<boolean>) {
      state.isLoadingGetVenues = action.payload
    }
  }
})

export const venueAction = venueSlice.actions

export default venueSlice.reducer
